import { FC, MouseEvent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from '@codex/basics';

const StyledLink = styled(Link)`
  color: black;
  float: right;
  margin-top: 10px;
  
  &:hover {
    color: black;
  }
`;

const Label = styled.span`
  margin-left: 5px;
`;

const ArrowIcon = styled.i`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;
  width: 10px;
  height: 10px;
  border-width: 3px 3px 0 0;
  border-style: solid;
  margin-bottom: 5px;
  transform: rotate(-45deg);
  &:before{
    content: "";
    box-sizing: border-box;
    right: 0;
    top: -2px;
    position: absolute;
    height: 3px;
    box-shadow: inset 0 0 0 32px;
    transform: rotate(-45deg);
    width: 11px;
    transform-origin: right top;
  }
`;

type Props = {
    handleClick(e: MouseEvent<HTMLElement>): void,
    label: string
};

const BackToTopLink: FC<Props> = ({ handleClick, label }) => (
  // eslint-disable-next-line react/react-in-jsx-scope
  <StyledLink onClick={handleClick}>
    <ArrowIcon />
    <Label>{label}</Label>
  </StyledLink>
);

BackToTopLink.displayName = 'BackToTopLink';

BackToTopLink.propTypes = {
  handleClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
};

export default BackToTopLink;
